import { GroupsPage } from 'features/groups';

export const AdminGroupsPage: React.FC = () => <GroupsPage />;
